class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden','search-open');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden','search-open');
  }
}

customElements.define('details-modal', DetailsModal);


class SearchModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.searchContainer = this.querySelector('.search-modal__content');
    this.headerSearch = this; 
    this.summaryToggle = this.querySelector('summary');
    this.closeButton = this.querySelector('.search-modal__close-button');

    this.searchContainer.style.transform = 'translateY(calc(-100% - var(--header-height)))';

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.closeButton.addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }
  initAccessibleFocusTrap() {
    const container = this.querySelector('.search-modal');

    if (!container) return;

    const focusableSelectors = `
      a[href],
      button:not([disabled]),
      textarea,
      input:not([type="hidden"]):not([disabled]),
      select:not([disabled]),
      [tabindex]:not([tabindex="-1"])
    `;

    const getFocusableElements = () =>
      Array.from(container.querySelectorAll(focusableSelectors))
        .filter(el => el.offsetParent !== null);

    this.handleKeydown = (e) => {
      if (e.key !== 'Tab') return;

      const focusable = getFocusableElements();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      // SHIFT + TAB (reverse)
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } 
      // TAB (forward)
      else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };

    container.addEventListener('keydown', this.handleKeydown);
    
    const focusable = getFocusableElements();
    if (focusable.length) {
      focusable[0].focus();
    }
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.isOpen() ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {
      this.close(false);
    }
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.searchContainer.style.transform = 'translateY(calc(-100% - var(--header-height)))';
    requestAnimationFrame(() => {
      this.detailsContainer.setAttribute('open', true);
      this.searchContainer.style.transform = '';
      this.headerSearch.classList.add('active');
      setTimeout(() => {
        document.body.addEventListener('click', this.onBodyClickEvent);
      }, 0);
      document.body.classList.add('overflow-hidden','search-open');

      this.initAccessibleFocusTrap();
    });
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.searchContainer.style.transform = 'translateY(calc(-100% - var(--header-height)))';
    this.headerSearch.classList.remove('active');

    const container = this.querySelector('.search-modal');
    if (this.handleKeydown) {
      container.removeEventListener('keydown', this.handleKeydown);
    }

    const handleTransitionEnd = () => {
      this.detailsContainer.removeAttribute('open');
      this.searchContainer.style.transform = 'translateY(calc(-100% - var(--header-height)))';
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove('overflow-hidden','search-open');
      this.searchContainer.removeEventListener('transitionend', handleTransitionEnd);
    };

    this.searchContainer.addEventListener('transitionend', handleTransitionEnd);

    setTimeout(() => {
      if (this.detailsContainer.hasAttribute('open')) {
        this.detailsContainer.removeAttribute('open');
        this.searchContainer.style.transform = 'translateY(calc(-100% - var(--header-height)))';
        document.body.removeEventListener('click', this.onBodyClickEvent);
        document.body.classList.remove('overflow-hidden','search-open');
        this.searchContainer.removeEventListener('transitionend', handleTransitionEnd);
      }
    }, 600);
  }
}

customElements.define('search-modal', SearchModal);